import { ModelAspectRatioMap } from "@/lib/aspectRatioUtils/types";

const modelAspectRatio: ModelAspectRatioMap = {
  imagen: {
    "1:1": "1024x1024",
    "3:4": "896x1280",
    "4:3": "1280x896",
    "9:16": "768x1408",
    "16:9": "1408x768",
  },
  nano_banana_pro: {
    "1:1": "1024x1024",
    "3:4": "896x1200",
    "4:3": "1200x896",
    "4:5": "928x1152",
    "5:4": "1152x928",
    "9:16": "768x1376",
    "16:9": "1376x768",
  },
  bria: {
    "1:1": "1024x1024",
    "3:4": "896x1152",
    "4:3": "1152x896",
    "9:16": "768x1344",
    "16:9": "1344x768",
    "4:5": "896x1088",
    "5:4": "1088x896",
  },
};

export default modelAspectRatio;
